import { render } from "./CustomerHome.vue?vue&type=template&id=aee52050"
import script from "./CustomerHome.vue?vue&type=script&lang=js"
export * from "./CustomerHome.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__